export default __webpack_public_path__ + "static/media/cheaper.02022780.svg";